import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/components/admin/AdminLayout.css";

/**
 * Gedeelde layout voor alle /admin-pagina's: rendert een zwarte titelbanner
 * (zelfde vorm als de groene "Mijn bestellingen"-hero) gevolgd door de
 * pagina-inhoud. De titel wordt afgeleid uit het pad — de app gebruikt een
 * component-router (BrowserRouter), dus useMatches/handle is hier niet
 * beschikbaar. Nieuwe admin-routes voeg je hieronder toe.
 */
const TITLE_BY_PREFIX: { prefix: string; key: string }[] = [
  { prefix: "/admin/shirt-list", key: "admin.banner.shirtList" },
  { prefix: "/admin/shirts", key: "admin.banner.shirts" },
  { prefix: "/admin/users", key: "admin.banner.users" },
  { prefix: "/admin/problem-reports", key: "admin.banner.problems" },
  { prefix: "/admin/disputes", key: "admin.banner.disputes" },
];

export default function AdminLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const match = TITLE_BY_PREFIX.find((m) => pathname.startsWith(m.prefix));

  return (
    <div className="admin-layout">
      <div className="admin-banner">
        <h1>{match ? t(match.key) : ""}</h1>
      </div>
      <Outlet />
    </div>
  );
}
